<div class="edit-component-dialog admin-modal" [class.minimised]="minimise">
  <!-- Header -->
  <div class="modal-header">
    <h3 class="modal-title">Add/Edit Component</h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         (click)="minimise = !minimise"
         [title]="minimise ? 'Expand' : 'Minimise'"></i>
      <i class="fa fa-times" (click)="cancel()" title="Close"></i>
    </div>
  </div>

  <!-- Body -->
  @if (!minimise) {
<div class="row modal-body">
    <!-- Left Panel: Settings -->
    <div class="col-md-6 h-100">

      <!-- General Settings Accordion -->
      <div class="panel panel-default">
        <div class="panel-heading" (click)="accordions.generalSettings = !accordions.generalSettings" style="cursor: pointer;">
          <span>General Settings</span>
          <i class="pull-right glyphicon"
             [ngClass]="{'glyphicon-chevron-down': accordions.generalSettings, 'glyphicon-chevron-right': !accordions.generalSettings}"></i>
        </div>
        @if (accordions.generalSettings) {
<div class="panel-body">
          <form #chartForm="ngForm">
            <div class="row">
              <!-- Title -->
              <div class="col-lg-4 col-md-6">
                <div class="mt-10">
                  <label>Title*:</label>
                  <input type="text" class="form-control" [(ngModel)]="component.title" name="title"
                         [class.error-field]="titleField.invalid && titleField.touched"
                         #titleField="ngModel" required>
                </div>
              </div>
              <!-- Row Title -->
              <div class="col-lg-4 col-md-6">
                <div class="mt-10">
                  <label>Row Title:</label>
                  <input type="text" class="form-control" [(ngModel)]="component.row_title" name="row_title">
                </div>
              </div>
              <!-- Component Id -->
              @if (component.component_id) {
<div class="col-lg-4 col-md-6">
                <div class="mt-10">
                  <label>Component Id:</label>
                  <input type="text" class="form-control" [(ngModel)]="component.component_id"
                         name="component_id" [disabled]="true" required>
                </div>
              </div>
}
              <!-- Height -->
              <div class="col-lg-4 col-md-6">
                <div class="mt-10">
                  <label>Height:</label>
                  <input type="text" class="form-control" [(ngModel)]="component.height"
                         placeholder="450px" name="height">
                </div>
              </div>
              <!-- Source Sheet -->
              <div class="col-lg-4 col-md-6">
                <div class="mt-10">
                  <label>Source Sheet*:</label>
                  <select class="form-control" [(ngModel)]="component.srcSheet"
                          (ngModelChange)="getActionData(component.srcSheet)"
                          [class.error-field]="srcSheetField.invalid && srcSheetField.touched"
                          #srcSheetField="ngModel" name="srcSheet" required>
                    @for (sheet of sheetData; track $index) {
<option [value]="sheet.name">{{sheet.name}}</option>
}
                  </select>
                </div>
              </div>
              <!-- Component Type -->
              <div class="col-lg-4 col-md-6">
                <div class="mt-10">
                  <label>Select Component Type*:</label>
                  <select class="form-control" [(ngModel)]="component.component_type"
                          (ngModelChange)="changeComponentType()"
                          [class.error-field]="compTypeField.invalid && compTypeField.touched"
                          #compTypeField="ngModel" name="component_type" required>
                    @for (c of definedComponentTypes; track $index) {
<option [value]="c">{{c}}</option>
}
                  </select>
                </div>
              </div>
              <!-- Strategy -->
              <div class="col-lg-4 col-md-6">
                <div class="mt-10" style="position: relative;">
                  <label>Strategy*:</label>
                  @if (component.strategy) {
<i class="fa fa-info pull-right view-function"
                     (click)="showFunction(component.strategy)"></i>
}
                  <select class="form-control" [(ngModel)]="component.strategy"
                          (ngModelChange)="component.extraOptions.strategySettings = {}; changeStrategy(component.strategy)"
                          [class.error-field]="strategyField.invalid && strategyField.touched"
                          #strategyField="ngModel" name="strategy" required>
                    @for (s of component.supportedStrategies; track $index) {
<option [value]="s.value">{{s.displayName}}</option>
}
                  </select>
                </div>
              </div>
              <!-- Filterable -->
              <div class="col-lg-4 col-md-6">
                <div class="switch-row">
                  <label>Filterable:</label>
                  <label class="switch">
                    <input type="checkbox" [(ngModel)]="component.filterable" name="filterable">
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
}
      </div>

      <!-- Strategy Settings Accordion -->
      <div class="panel panel-default">
        <div class="panel-heading" (click)="accordions.strategySettings = !accordions.strategySettings" style="cursor: pointer;">
          <span>Strategy Settings</span>
          <i class="pull-right glyphicon"
             [ngClass]="{'glyphicon-chevron-down': accordions.strategySettings, 'glyphicon-chevron-right': !accordions.strategySettings}"></i>
        </div>
        @if (accordions.strategySettings) {
<div class="panel-body">
          <div class="row">
            @for (input of strategyInputs; track $index) {
<div class="col-lg-4 col-md-6">
              @if (input.selectionMode === 'single' || input.selectionMode === 'multiple') {
<div class="mt-10">
                <label>{{input.name}}</label>
                @if (input.selectionMode === 'single') {
<select class="form-control"
                        [(ngModel)]="component.extraOptions.strategySettings[input.key]"
                        (ngModelChange)="reRenderComponent()">
                  @for (column of actionData; track $index) {
<option [value]="column">{{column}}</option>
}
                </select>
}
                @if (input.selectionMode === 'multiple') {
<select class="form-control" multiple
                        [(ngModel)]="component.extraOptions.strategySettings[input.key]"
                        (ngModelChange)="reRenderComponent()">
                  @for (column of actionData; track $index) {
<option [value]="column">{{column}}</option>
}
                </select>
}
              </div>
}
              @if (input.selectionMode === 'toggle') {
<div class="switch-row">
                <label>{{input.name}}</label>
                <label class="switch">
                  <input type="checkbox" [(ngModel)]="component.extraOptions.strategySettings[input.key]"
                         (ngModelChange)="reRenderComponent()">
                  <span class="slider round"></span>
                </label>
              </div>
}
            </div>
}
          </div>
          <!-- Default Filter -->
          <div class="row mt-10">
            <div class="col-lg-12">
              <div class="switch-row">
                <label>Default Filter:</label>
                <label class="switch">
                  <input type="checkbox" [(ngModel)]="component.extraOptions.strategySettings.is_default_filter"
                         (ngModelChange)="reRenderComponent()">
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>
          @if (component.extraOptions.strategySettings.is_default_filter) {
<div class="row">
            <div class="suboptions-panel">
              <div class="row">
                <div class="col-lg-4 col-md-6">
                  <label>Default Filter By:</label>
                  <select class="form-control"
                          [(ngModel)]="component.extraOptions.strategySettings.default_filter_by"
                          (ngModelChange)="defaultFilterByChanged()">
                    @for (column of actionData; track $index) {
<option [value]="column">{{column}}</option>
}
                  </select>
                </div>
                <div class="col-lg-4 col-md-6">
                  <label>Default Filter Value:</label>
                  <select class="form-control"
                          [(ngModel)]="component.extraOptions.strategySettings.default_filter_value"
                          (ngModelChange)="reRenderComponent()">
                    @for (value of defaultFilterValues; track $index) {
<option [value]="value">{{value}}</option>
}
                  </select>
                </div>
              </div>
            </div>
          </div>
}
        </div>
}
      </div>

      <!-- Component Specific Settings Accordion -->
      <div class="panel panel-default">
        <div class="panel-heading" (click)="accordions.compSpecificSettings = !accordions.compSpecificSettings" style="cursor: pointer;">
          <span>Component specific settings</span>
          <i class="pull-right glyphicon"
             [ngClass]="{'glyphicon-chevron-down': accordions.compSpecificSettings, 'glyphicon-chevron-right': !accordions.compSpecificSettings}"></i>
        </div>
        @if (accordions.compSpecificSettings) {
<div class="panel-body">

          <!-- Chart-specific settings (chart + combinationChart) -->
          @if (hasChartSettings()) {

            <div class="row">
              <!-- Chart Type -->
              <div class="col-lg-4 col-md-6">
                <div class="mt-10">
                  <label>Chart Type:</label>
                  <select class="form-control"
                          [(ngModel)]="component.extraOptions.componentSettings.chart.type"
                          (ngModelChange)="initChart(); reRenderComponent()">
                    <option value="line">Line</option>
                    <option value="bar">Bar</option>
                    <option value="area">Area</option>
                    <option value="column">Column</option>
                    <option value="spline">Spline</option>
                    <option value="pie">Pie</option>
                    <option value="variablepie">Donut</option>
                    <option value="packedbubble">Packed Bubble</option>
                    <option value="waterfall">Waterfall</option>
                    <option value="sunburst">Sunburst</option>
                  </select>
                </div>
              </div>
              <!-- Stacking -->
              <div class="col-lg-4 col-md-6">
                <div class="mt-10">
                  <label>Stacking</label>
                  <select class="form-control"
                          [(ngModel)]="component.extraOptions.componentSettings.plotOptions.series.stacking"
                          (ngModelChange)="reRenderComponent()">
                    <option value="">None</option>
                    <option value="normal">Normal</option>
                    <option value="percent">Percent</option>
                  </select>
                </div>
              </div>
              <!-- Padding b/w data points -->
              <div class="col-lg-4 col-md-6">
                <div class="mt-10">
                  <label>Padding b/w data points (0-1):</label>
                  <input type="number" class="form-control" min="0" max="1" step="0.1"
                         [(ngModel)]="component.extraOptions.componentSettings.plotOptions.series.groupPadding"
                         (change)="reRenderComponent()">
                </div>
              </div>
              <!-- Waterfall colors -->
              @if (component.extraOptions.componentSettings.chart.type === 'waterfall') {
<div class="col-lg-2 col-md-2">
                <div class="mt-10">
                  <label>Up Color:</label>
                  <input type="color" class="form-control"
                         [(ngModel)]="component.extraOptions.componentSettings.plotOptions.series.upColor"
                         (blur)="reRenderComponent()">
                </div>
              </div>
}
              @if (component.extraOptions.componentSettings.chart.type === 'waterfall') {
<div class="col-lg-2 col-md-2">
                <div class="mt-10">
                  <label>Down Color:</label>
                  <input type="color" class="form-control"
                         [(ngModel)]="component.extraOptions.componentSettings.plotOptions.series.color"
                         (blur)="reRenderComponent()">
                </div>
              </div>
}
              <!-- Enable Legends -->
              <div class="col-lg-4 col-md-6">
                <div class="switch-row">
                  <label>Enable Legends:</label>
                  <label class="switch">
                    <input type="checkbox"
                           [(ngModel)]="component.extraOptions.componentSettings.legend.enabled"
                           (ngModelChange)="reRenderComponent()">
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
            </div>

            <!-- 3D toggle -->
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-lg-4 col-md-6">
                    <div class="switch-row">
                      <label>3D:</label>
                      <label class="switch">
                        <input type="checkbox"
                               [(ngModel)]="component.extraOptions.componentSettings.chart.options3d.enabled"
                               (ngModelChange)="reRenderComponent()">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </div>
                </div>
                @if (component.extraOptions.componentSettings.chart.options3d.enabled) {
<div class="suboptions-panel"
                    >
                  <div class="row">
                    <div class="col-lg-3 col-md-6">
                      <label>Alpha Angle: {{component.extraOptions.componentSettings.chart.options3d.alpha}}</label>
                      <input type="range" min="0" max="50"
                             [(ngModel)]="component.extraOptions.componentSettings.chart.options3d.alpha"
                             (change)="reRenderComponent()">
                    </div>
                    <div class="col-lg-3 col-md-6">
                      <label>Beta Angle: {{component.extraOptions.componentSettings.chart.options3d.beta}}</label>
                      <input type="range" min="0" max="50"
                             [(ngModel)]="component.extraOptions.componentSettings.chart.options3d.beta"
                             (change)="reRenderComponent()">
                    </div>
                    <div class="col-lg-3 col-md-6">
                      <label>Depth: {{component.extraOptions.componentSettings.chart.options3d.depth}}</label>
                      <input type="range" min="0" max="50"
                             [(ngModel)]="component.extraOptions.componentSettings.chart.options3d.depth"
                             (change)="reRenderComponent()">
                    </div>
                    <div class="col-lg-3 col-md-6">
                      <label>View Distance: {{component.extraOptions.componentSettings.chart.options3d.viewDistance}}</label>
                      <input type="range" min="0" max="50"
                             [(ngModel)]="component.extraOptions.componentSettings.chart.options3d.viewDistance"
                             (change)="reRenderComponent()">
                    </div>
                  </div>
                </div>
}
              </div>
            </div>

            <!-- Misc options -->
            <div class="row">
              <div class="col-lg-4 col-md-6">
                <div class="mt-10">
                  <label>Event broadcast message on data point click:</label>
                  <input type="text" class="form-control"
                         [(ngModel)]="component.extraOptions.componentSettings.eventMessage"
                         (change)="reRenderComponent()">
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="switch-row">
                  <label>Enable Custom Coloring:</label>
                  <label class="switch">
                    <input type="checkbox"
                           [(ngModel)]="component.extraOptions.componentSettings.customColors.enabled"
                           (ngModelChange)="reRenderComponent()">
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="switch-row">
                  <label>Disable Smooth Scale on Resize:</label>
                  <label class="switch">
                    <input type="checkbox"
                           [(ngModel)]="component.extraOptions.componentSettings.disableSmoothScale"
                           (ngModelChange)="reRenderComponent()">
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
            </div>

            <!-- Stack Labels (only when stacking) -->
            @if (component.extraOptions.componentSettings.plotOptions.series.stacking) {
<div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-lg-4 col-md-6">
                    <div class="switch-row">
                      <label>Enable Stack Labels:</label>
                      <label class="switch">
                        <input type="checkbox"
                               [(ngModel)]="component.extraOptions.componentSettings.yAxis.stackLabels.enabled"
                               (ngModelChange)="formatChanged('yAxis.stackLabels','{total}')">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </div>
                </div>
                @if (component.extraOptions.componentSettings.yAxis.stackLabels.enabled) {
<div class="suboptions-panel"
                    >
                  <div class="row">
                    <div class="col-lg-4 col-md-6">
                      <label>Stack Label Format:</label>
                      <select class="form-control"
                              [(ngModel)]="component.extraOptions.componentSettings.yAxis.stackLabels.formatter"
                              (ngModelChange)="formatChanged('yAxis.stackLabels','{total}')">
                        @for (f of formatters; track $index) {
<option [value]="f.name">{{f.name}}</option>
}
                      </select>
                    </div>
                    @if (!component.extraOptions.componentSettings.yAxis.stackLabels.formatter || component.extraOptions.componentSettings.yAxis.stackLabels.formatter === 'None') {
<div class="col-lg-4 col-md-6"
                        >
                      <label>Highcharts Formatting:</label>
                      <input type="text" class="form-control"
                             [(ngModel)]="component.extraOptions.componentSettings.yAxis.stackLabels.format"
                             (blur)="reRenderComponent()">
                    </div>
}
                  </div>
                </div>
}
              </div>
            </div>
}

            <!-- Data Labels -->
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-lg-4 col-md-6">
                    <div class="switch-row">
                      <label>Enable Data Labels:</label>
                      <label class="switch">
                        <input type="checkbox"
                               [(ngModel)]="component.extraOptions.componentSettings.plotOptions.series.dataLabels.enabled"
                               (ngModelChange)="formatChanged('plotOptions.series.dataLabels','{point.y}')">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </div>
                </div>
                @if (component.extraOptions.componentSettings.plotOptions.series.dataLabels.enabled) {
<div class="suboptions-panel"
                    >
                  <div class="row">
                    <div class="col-lg-4 col-md-6">
                      <div class="switch-row">
                        <label>Use series as label:</label>
                        <label class="switch">
                          <input type="checkbox"
                                 [(ngModel)]="component.extraOptions.componentSettings.plotOptions.series.dataLabels.seriesAsLabel"
                                 (ngModelChange)="formatChanged('plotOptions.series.dataLabels','{point.y}')">
                          <span class="slider round"></span>
                        </label>
                      </div>
                    </div>
                    @if (!component.extraOptions.componentSettings.plotOptions.series.dataLabels.seriesAsLabel) {

                      <div class="col-lg-4 col-md-6">
                        <label>Datalabel Format:</label>
                        <select class="form-control"
                                [(ngModel)]="component.extraOptions.componentSettings.plotOptions.series.dataLabels.formatter"
                                (ngModelChange)="formatChanged('plotOptions.series.dataLabels','{point.y}')">
                          @for (f of formatters; track $index) {
<option [value]="f.name">{{f.name}}</option>
}
                        </select>
                      </div>
                      @if (!component.extraOptions.componentSettings.plotOptions.series.dataLabels.formatter || component.extraOptions.componentSettings.plotOptions.series.dataLabels.formatter === 'None') {
<div class="col-lg-4 col-md-6"
                          >
                        <label>Highcharts Formatting:</label>
                        <input type="text" class="form-control"
                               [(ngModel)]="component.extraOptions.componentSettings.plotOptions.series.dataLabels.format"
                               (blur)="reRenderComponent()">
                      </div>
}
                    
}
                    <div class="col-lg-4 col-md-6">
                      <div class="switch-row">
                        <label>Inside:</label>
                        <label class="switch">
                          <input type="checkbox"
                                 [(ngModel)]="component.extraOptions.componentSettings.plotOptions.series.dataLabels.inside"
                                 (ngModelChange)="formatChanged('plotOptions.series.dataLabels','{point.y}')">
                          <span class="slider round"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
}
              </div>
            </div>

            <!-- Tooltip -->
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-lg-4 col-md-6">
                    <div class="switch-row">
                      <label>Enable Tooltip:</label>
                      <label class="switch">
                        <input type="checkbox"
                               [(ngModel)]="component.extraOptions.componentSettings.tooltip.enabled"
                               (ngModelChange)="reRenderComponent()">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </div>
                  @if (component.extraOptions.componentSettings.tooltip.enabled) {
<div class="col-lg-4 col-md-6"
                      >
                    <div class="switch-row">
                      <label>Shared Tooltip:</label>
                      <label class="switch">
                        <input type="checkbox"
                               [(ngModel)]="component.extraOptions.componentSettings.tooltip.shared"
                               (ngModelChange)="reRenderComponent()">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </div>
}
                </div>
                @if (component.extraOptions.componentSettings.tooltip.enabled) {
<div class="suboptions-panel"
                    >
                  <div class="row">
                    <div class="col-lg-4 col-md-6">
                      <label>Tooltip Format:</label>
                      <select class="form-control"
                              [(ngModel)]="component.extraOptions.componentSettings.tooltip.formatter"
                              (ngModelChange)="formatChanged('tooltip', null)">
                        @for (f of formatters; track $index) {
<option [value]="f.name">{{f.name}}</option>
}
                      </select>
                    </div>
                    @if (!component.extraOptions.componentSettings.tooltip.formatter || component.extraOptions.componentSettings.tooltip.formatter === 'None') {
<div class="col-lg-4 col-md-6"
                        >
                      <label>Highcharts Formatting:</label>
                      <input type="text" class="form-control"
                             [(ngModel)]="component.extraOptions.componentSettings.tooltip.pointFormat"
                             (blur)="reRenderComponent()">
                    </div>
}
                  </div>
                </div>
}
              </div>
            </div>

            <!-- Scroll / max datapoints -->
            <div class="row">
              <div class="col-lg-4 col-md-6">
                <div class="switch-row">
                  <label>Enable Scroll:</label>
                  <label class="switch">
                    <input type="checkbox"
                           [(ngModel)]="component.extraOptions.componentSettings.xAxis.scrollbar.enabled"
                           (ngModelChange)="reRenderComponent()">
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="mt-10">
                  <label>Max datapoints in the view:</label>
                  <input type="number" class="form-control"
                         [(ngModel)]="component.extraOptions.componentSettings.xAxis.max"
                         (change)="reRenderComponent()">
                </div>
              </div>
            </div>

            <!-- Individual Series Settings -->
            @if (component.extraOptions.componentSettings?.dataOverrides?.series?.length) {
<div class="row mt-10"
                >
              <div class="col-md-12">
                <label>Individual Series Settings:</label>
                @for (series of component.extraOptions.componentSettings.dataOverrides.series; track $index; let i = $index) {
<div class="sheet-border"
                    >
                  <div class="flex-box">
                    <label>Series Name:</label>
                    <input type="text" class="form-control" [disabled]="true"
                           [(ngModel)]="series.name"
                           [ngModelOptions]="{standalone: true}">
                  </div>
                  <div class="flex-box">
                    <label>Display Name:</label>
                    <input type="text" class="form-control"
                           [(ngModel)]="series.displayName"
                           (blur)="reRenderComponent()"
                           [ngModelOptions]="{standalone: true}">
                  </div>
                  <div class="flex-box">
                    <label>Stacking:</label>
                    <select class="form-control"
                            [(ngModel)]="series.stacking"
                            (ngModelChange)="reRenderComponent()"
                            [ngModelOptions]="{standalone: true}">
                      <option value="">None</option>
                      <option value="normal">Normal</option>
                    </select>
                  </div>
                  <div class="flex-box">
                    <label>Color:</label>
                    <input type="color" class="form-control"
                           [(ngModel)]="series.color"
                           (blur)="reRenderComponent()"
                           [ngModelOptions]="{standalone: true}">
                  </div>
                  <div class="flex-box">
                    <div class="switch-row">
                      <label>Color By Point:</label>
                      <label class="switch">
                        <input type="checkbox"
                               [(ngModel)]="series.colorByPoint"
                               (ngModelChange)="reRenderComponent()"
                               [ngModelOptions]="{standalone: true}">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </div>
                  <div class="flex-box">
                    <div class="switch-row">
                      <label>Drill Down:</label>
                      <label class="switch">
                        <input type="checkbox"
                               [(ngModel)]="series.allowDrillToNode"
                               (ngModelChange)="reRenderComponent()"
                               [ngModelOptions]="{standalone: true}">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </div>
                </div>
}
              </div>
            </div>
}
          
}

          <!-- Fallback for component types without a settings template yet -->
          @if (!hasChartSettings()) {
<p class="text-muted">
            No component-specific settings template available.
          </p>
}
        </div>
}
      </div>

      <!-- KPIs Accordion -->
      <div class="panel panel-default">
        <div class="panel-heading" (click)="accordions.kpis = !accordions.kpis" style="cursor: pointer;">
          <span>KPIs</span>
          <i class="pull-right glyphicon"
             [ngClass]="{'glyphicon-chevron-down': accordions.kpis, 'glyphicon-chevron-right': !accordions.kpis}"></i>
        </div>
        @if (accordions.kpis) {
<div class="panel-body">
          @for (kpi of component.extraOptions?.kpis; track $index; let i = $index) {
<div class="sheet-border">
            <div class="flex-box">
              <label>Label:</label>
              <input type="text" class="form-control" [(ngModel)]="kpi.extraOptions.label"
                     [ngModelOptions]="{standalone: true}">
            </div>
            <div class="flex-box">
              <label>Strategy:</label>
              <select class="form-control" [(ngModel)]="kpi.strategy"
                      (ngModelChange)="initKpiStrategyInputs(kpi)"
                      [ngModelOptions]="{standalone: true}">
                @for (s of kpiStrategies; track $index) {
<option [value]="s.value">{{s.displayName}}</option>
}
              </select>
            </div>
            @for (input of kpi.kpiStrategyInputs; track $index) {
<div class="flex-box">
              <label>{{input.name}}:</label>
              @if (input.selectionMode === 'single') {
<select class="form-control"
                      [(ngModel)]="kpi.extraOptions.strategySettings[input.key]"
                      (ngModelChange)="reRenderComponent()"
                      [ngModelOptions]="{standalone: true}">
                @for (column of actionData; track $index) {
<option [value]="column">{{column}}</option>
}
              </select>
}
              @if (input.type === 'input') {
<input class="form-control"
                     [(ngModel)]="kpi.extraOptions.strategySettings[input.key]"
                     (blur)="reRenderComponent()"
                     [ngModelOptions]="{standalone: true}">
}
            </div>
}
            <div class="flex-box">
              <label>Format:</label>
              <select class="form-control" [(ngModel)]="kpi.extraOptions.componentSettings.format"
                      (ngModelChange)="reRenderComponent()"
                      [ngModelOptions]="{standalone: true}">
                @for (formatter of formatters; track $index) {
<option [value]="formatter.name">{{formatter.name}}</option>
}
              </select>
            </div>
            <div class="flex-box">
              <div class="switch-row">
                <label>Default Filter:</label>
                <label class="switch">
                  <input type="checkbox" [(ngModel)]="kpi.extraOptions.strategySettings.is_default_filter"
                         (ngModelChange)="reRenderComponent()"
                         [ngModelOptions]="{standalone: true}">
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
            @if (kpi.extraOptions.strategySettings.is_default_filter) {
<div class="flex-box">
              <label>Default Filter By:</label>
              <select class="form-control"
                      [(ngModel)]="kpi.extraOptions.strategySettings.default_filter_by"
                      (ngModelChange)="defaultFilterByChanged()"
                      [ngModelOptions]="{standalone: true}">
                @for (column of actionData; track $index) {
<option [value]="column">{{column}}</option>
}
              </select>
            </div>
}
            @if (kpi.extraOptions.strategySettings.is_default_filter) {
<div class="flex-box">
              <label>Default Filter Value:</label>
              <select class="form-control"
                      [(ngModel)]="kpi.extraOptions.strategySettings.default_filter_value"
                      (ngModelChange)="reRenderComponent()"
                      [ngModelOptions]="{standalone: true}">
                @for (value of defaultFilterValues; track $index) {
<option [value]="value">{{value}}</option>
}
              </select>
            </div>
}
            <div class="flex-box">
              <i class="fa fa-minus-circle del-icn" (click)="removeKpiRow(i)"
                 [class.disabled-button]="component.extraOptions.kpis?.length === 1"></i>
            </div>
          </div>
}
          <div>
            <i class="fa fa-plus-circle fa-lg plus-icn" (click)="addKpiRow()"></i>
          </div>
        </div>
}
      </div>

    </div>

    <!-- Right Panel: Preview -->
    <div class="col-md-6 h-100">
      <div class="row h-100">
        <div class="col-md-12">
          <div class="panel panel-default">
            <div class="panel-heading">
              @if (!jsonView) {
<button class="btn btn-default btn-md" (click)="jsonView = true">JSON View</button>
}
              @if (jsonView) {
<button class="btn btn-default btn-md" (click)="jsonView = false">Live view</button>
}
              @if (!fullData) {
<button class="btn btn-default btn-md pull-right"
                      (click)="fullData = true; reRenderComponent()">View Full Data</button>
}
              @if (fullData) {
<button class="btn btn-default btn-md pull-right"
                      (click)="fullData = false; reRenderComponent()">View Less Data</button>
}
            </div>
            <!-- JSON View -->
            @if (jsonView) {
<div class="panel-body">
              <textarea class="form-control" [(ngModel)]="compJsonObj" style="height: 60vh;"></textarea>
            </div>
}
            <!-- Live View -->
            @if (!jsonView) {
<div class="panel-body">
              @if (actionLoading) {
<div class="text-center p-10">
                <i class="fa fa-spinner fa-spin fa-2x"></i>
              </div>
}
              @if (chartView && !actionLoading) {
<div>
                <gtw-ex-component-resolver [options]="component"></gtw-ex-component-resolver>
              </div>
}
              @if (!chartView && !actionLoading) {
<div class="text-center text-muted p-10">
                Select a source sheet and strategy to preview the component.
              </div>
}
            </div>
}
            <!-- JSON Apply Footer -->
            @if (jsonView) {
<div class="panel-footer">
              <button class="btn btn-success btn-md" (click)="applyJsonObj()">Apply Json</button>
            </div>
}
          </div>
        </div>
      </div>
    </div>
  </div>
}

  <!-- Footer -->
  @if (!minimise) {
<div class="modal-footer">
    <button class="btn btn-info btn-sm" type="submit" [disabled]="isSaveDisabled()" (click)="save()">Save</button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
  </div>
}
</div>
